export const OVERLAYS = {
  poster: {
    class: "poster-overlay",
    content: "",
    start: "showPoster",
    end: "hidePoster",
  },
  beforeStartNotice: {
    class: "notice-overlay",
    content: "This webcast will start shortly.<br>Thank you for your patience.",
    align: "bottom",
    start: "showNotice",
    end: "hideNotice",
  },
  afterStopNotice: {
    class: "notice-overlay",
    content: "The webcast is over or not available.",
    align: "bottom",
    start: "showNotice",
    end: "hideNotice",
  },
};
